module.exports = __webpack_public_path__ + "media/images/flags/bd-cdbfe8d5d9dedda3b31461c2279a3bb4.svg";